import React from 'react'

import Base from '../_Base'

const Star75 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M15.2652212,8.56569256 L11.9870911,1.93673376 L8.72922116,8.56569256 L1.43051684,9.61109415 L6.70922116,14.7416926 L5.46398806,22.0622966 L11.9982212,18.6036926 L18.5431546,22.0632662 L17.2842212,14.7416926 L22.5694832,9.61123163 L15.2652212,8.56569256 Z M15.1383358,10.5680086 L18.2532212,11.0136926 L15.1355582,14.0411449 L15.8832212,18.3946926 L15.1361651,17.9997916 L15.1355582,14.0411449 L15.1383358,10.5680086 Z" />
  </Base>
)

export default Star75
